import { createContext } from 'react';

const RootElementContext = createContext<Element | null>(null);
RootElementContext.displayName = 'RootElementContext';

export { RootElementContext };
